import { createContext, useContext, useState, type ReactNode } from "react";

/**
 * AssignmentActivitySelection API shape for
 * assignment.assignment_activity_selection.selected_activities
 * {
      <quiz1_content_id>: [<question_content_id1>, <question_content_id2>],
      <quiz2_content_id>: [<question_content_id1>, <question_content_id2>]
    }
 */
export interface InitialActivitySelections {
  [key: string]: string[];
}

interface AssignmentActivitySelectionProviderProps {
  children: ReactNode;
  initialActivitySelections: InitialActivitySelections;
}

export const AssignmentActivitySelectionContext = createContext({});

const useAssignmentActivitySelectionContext = () => {
  const assignmentActivitySelectionCtx = useContext(
    AssignmentActivitySelectionContext,
  );

  if (assignmentActivitySelectionCtx === undefined) {
    throw new Error(
      "useAssignmentActivitySelectionContext must be used within a AssignmentActivitySelectionProvider.",
    );
  }

  return assignmentActivitySelectionCtx;
};

export const AssignmentActivitySelectionProvider = ({
  children,
  initialActivitySelections = {},
}: AssignmentActivitySelectionProviderProps) => {
  const [selectedActivities, setSelectedActivities] = useState(
    initialActivitySelections,
  );
  const contextData = { selectedActivities, setSelectedActivities };

  return (
    <AssignmentActivitySelectionContext.Provider value={contextData}>
      {children}
    </AssignmentActivitySelectionContext.Provider>
  );
};

export default useAssignmentActivitySelectionContext;
